import { render, staticRenderFns } from "./LimitedSubscription.vue?vue&type=template&id=c712a134&"
import script from "./LimitedSubscription.vue?vue&type=script&lang=js&"
export * from "./LimitedSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports